import React from "react";
import clsx from "clsx";
import { Layers2 } from "lucide-react";

import { Badge } from "@/design-system/components/Badge/Badge";
import { Typography } from "@/design-system/components/Typography/Typography";

type EnvironmentCardProps = {
  label: string;
  projectName: string;
  envName: string;
  highlighted?: boolean;
  isNew?: boolean;
};

/** Shows a project › environment pair the way the sidebar picker does. */
export function EnvironmentCard({
  label,
  projectName,
  envName,
  highlighted = false,
  isNew = false,
}: EnvironmentCardProps) {
  return (
    <div
      className={clsx(
        "flex flex-1 flex-col gap-2 rounded-lg border p-4",
        highlighted
          ? "border-interactive-selected bg-surface-selected"
          : "border-borderSubtle",
      )}
    >
      <Typography variant="eyebrow-xs">{label}</Typography>
      <div className="flex items-center gap-3">
        <Layers2
          className="text-iconDefault size-icon-md shrink-0"
          aria-hidden
        />
        <div className="flex min-w-0 flex-col">
          <span className="text-body-xs text-textTertiary truncate">
            {projectName}
          </span>
          <span className="text-heading-sm text-textPrimary flex items-center gap-2 truncate">
            {envName}
            {isNew && <Badge variant="info" text="New" />}
          </span>
        </div>
      </div>
    </div>
  );
}
